import { useField } from "formik";
import { useEffect } from "react";
import type { OnChangeValue } from "react-select";

import useChangeLocation from "../../hooks/useChangeLocation";
import useLocation from "../../hooks/useLocation";
import formatDropdownData from "../Dropdown/formatDropdownData";
import type { DropdownOption } from "./UI";
import UI from "./UI";

interface CountryDropdownProps {
  label: string;
  name: string;
  onChange?: (e: { target: { value: string } }) => void;
}

const CountryDropdown = ({ ...props }: CountryDropdownProps) => {
  const { states, state, currentCountry } = useLocation();
  const { changeLocation } = useChangeLocation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_field, meta, helpers] = useField(props);
  const { value } = meta;
  const { setValue } = helpers;

  useEffect(() => {
    if (value !== state) {
      setValue(state || "");
    }
  }, [setValue, state, value]);

  if (!states || states.length === 0) return null;

  const options = formatDropdownData(states, {
    value: "state",
    label: "name",
  });

  const ChangeEvent = (e: OnChangeValue<DropdownOption, false>): void => {
    if (props.onChange) {
      props.onChange({ target: { value: e?.value || "" } });
    }

    changeLocation.mutate({
      stateId: e?.value || "",
      locationId: currentCountry?.country || "",
    });
  };

  return <UI options={options} onChange={ChangeEvent} value={value} />;
};

export default CountryDropdown;
